import type {
  IProductGroup,
  IProductGroupOverview,
  IProductGroupParentChildObject,
} from './../types/product/models'
import { httpGet, httpPost, httpPatchMerge, httpDelete } from './http'
import { ProductLevelIds } from './selectLists/productLevels'
import type { TEntityId } from '~/types/models'
import { isKitProduct } from '~/types/product/models'

const apiEntityPath = '/api/productgroups'

export async function getProductGroups({ apiPath = apiEntityPath } = {}) {
  const callingMn = getProductGroups.name
  return httpGet<IProductGroup[]>({ callingMn, apiPath })
}

export async function getProductGroupOverview(id: string) {
  const callingMn = getProductGroupOverview.name
  const apiPath = `${apiEntityPath}/${id}/overview`
  return httpGet<IProductGroupOverview>({ callingMn, apiPath })
}

export async function getProductsForProductGroup(id: string) {
  const productGroupOverview = await getProductGroupOverview(id)
  return productGroupOverview.products.map((product) => product)
}

export async function getStandAloneAndKitProductsForProductGroup(id: string) {
  const productGroupOverview = await getProductGroupOverview(id)
  return productGroupOverview.products
    .filter(
      (product) =>
        !product.inKitOnly || (isKitProduct(product) && !product.inKitOnly)
    )
    .map((product) => product)
}

export async function getProductGroupParentChildObject(id: string) {
  const fn = `[services/productGroups.ts] ${getProductGroupParentChildObject.name} |`
  console.debug(`${fn} calling getProductGroupOverview`)
  const overview = await getProductGroupOverview(id)
  const parentChildObject: IProductGroupParentChildObject = {
    parent: {
      entityName: 'productGroup',
      object: {
        id: overview.productGroup.id, // Was returning whole object. Trying this. JR.
        label: overview.productGroup.descr,
        parent: overview.productGroup.productSubcategory, // up-link to subcategory
      },
    },
    children: {
      entityName: 'product',
      entityDataItems: overview.products,
    },
  }
  return parentChildObject
}

export async function createProductGroup(entity: IProductGroup) {
  const callingMn = createProductGroup.name
  const apiPath = apiEntityPath
  return httpPost<IProductGroup>({ callingMn, apiPath, entity })
}

export async function updateProductGroup(
  entityData: Partial<IProductGroup>,
  id: TEntityId
) {
  const callingMn = updateProductGroup.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialIProductGroup = Partial<IProductGroup>
  return httpPatchMerge<TPartialIProductGroup>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteProductGroup(entityData: IProductGroup) {
  const callingMn = deleteProductGroup.name
  const apiPath = apiEntityPath
  return httpDelete({
    callingMn,
    apiPath,
    entityData,
  })
}
